import React from "react";
import notFound from "../../assets/img/ReUse/notFound.svg";

const NoRecord = () => {
  // const CSSProperties = {
  //   display: "flex",
  //   minHeight: "100vh",
  //   flexDirection: "column",
  //   justifyContent: "center",
  //   alignItems: "center",
  // };

  return (
    <div className="notFound-container">
      <img src={notFound} alt="not found" className="image-fluid" />
      {/* <p className="mt-4">No Record Found</p> */}
    </div>
  );
};

export default NoRecord;
